import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { State } from '../../models/application/state.interface';
import { shareReplay } from 'rxjs/operators';
import { Country, Province } from '@edassist/api';

@Injectable({ providedIn: 'root' })
export class StateService {
	private readonly relativeUrl = 'states';
	private states$: Observable<Array<State>>;
	private countries$: Observable<Array<Country>>;
	private readonly provincesByCountry = new Map<string, Observable<Array<Province>>>();

	private readonly countriesRelativeUrl = 'countries';

	constructor(private readonly http: HttpClient) {}

	getStates(filterOption?: number): Observable<Array<State>> {
		if (!this.states$) {
			this.states$ = this.http
				.get<Array<State>>(`${this.relativeUrl}?filterOption=${filterOption}`)
				.pipe(shareReplay(1));
		}

		return this.states$;
	}

	getProvincesByCountry(countryCode: string): Observable<Array<Province>> {
		if (!this.provincesByCountry.has(countryCode)) {
			const provinces$ = this.http
				.get<Array<Province>>(`${this.countriesRelativeUrl}/${countryCode}/provinces`)
				.pipe(shareReplay(1));

			this.provincesByCountry.set(countryCode, provinces$);
		}

		return this.provincesByCountry.get(countryCode);
	}

	getCountries(): Observable<Array<Country>> {
		if (!this.countries$) {
			this.countries$ = this.http
				.get<Array<Country>>(`${this.countriesRelativeUrl}`)
				.pipe(shareReplay(1));
		}

		return this.countries$;
	}
}
